"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentTypes = require("./ComponentTypes");
var getColumnCount = function (dashboard) {
    return dashboard && dashboard.component && dashboard.component.type === ComponentTypes.hsplit ?
        dashboard.component.columnCount : 0;
};
exports.getColumnCount = getColumnCount;
var getRowCount = function (dashboard) {
    return dashboard && dashboard.component && dashboard.component.type === ComponentTypes.vsplit ?
        dashboard.component.rowCount : 0;
};
exports.getRowCount = getRowCount;
var assignWindows = function (windows, stacks) {
    if (windows && windows.length > 0) {
        var stackQuota_1 = Math.ceil(windows.length / stacks.length);
        var stackIdx_1 = 0;
        var c_1;
        windows.forEach(function (w) {
            c_1 = stacks[stackIdx_1];
            if (c_1.windowCount === stackQuota_1) {
                stackIdx_1++;
                c_1 = stacks[stackIdx_1];
            }
            c_1.add(w, false);
        });
        stacks.forEach(function (c) {
            if (c.windowCount > 0) {
                c.setActiveIndex(0);
            }
            else {
                c.addNew();
            }
        });
    }
};
exports.assignWindows = assignWindows;
